import script from "./sf-dropdown-multiselect.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-dropdown-multiselect.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__